import VectorLayer from 'ol/layer/Vector';
import { Vector as VectorSource } from 'ol/source.js';

import { Style } from 'ol/style.js';
import Icon from 'ol/style/Icon.js';

import planeURL from './plane.svg?url';
import { Feature } from 'ol';
import { Point } from 'ol/geom';
import { fromLonLat, toLonLat } from 'ol/proj';

const vectorLayer = new VectorLayer({
  source: new VectorSource({
    attributions: "<a href='https://adsb.lol/'>adsb.lol</a> (<a href='https://opendatacommons.org/licenses/odbl/'>ODbL</a>)",
    loader: async function (extent, resolution, projection) {
      const center = [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
      const [lon, lat] = toLonLat(center, projection);
      const res = await fetch(`https://maps.chandlerswift.com/proxy?url=${encodeURIComponent(`https://api.adsb.lol/v2/point/${lat}/${lon}/250`)}`);
      const planes = await res.json();
      console.log(planes);

      for (let plane of planes.ac) {
        this.addFeature(new Feature({
          geometry: new Point(fromLonLat([plane.lon, plane.lat])),
          ...plane,
        }))
      }
    },
  }),
  style: function (feature) {
    return new Style({
      image: new Icon({
        anchor: [0.5, 0.5],
        src: planeURL,
        rotateWithView: true,
        rotation: feature.get("track") * Math.PI / 180,
      }),
    });
  },
});

setInterval(() => vectorLayer.getSource().refresh(), 10000);

export default vectorLayer;
